module.exports = __webpack_public_path__ + "static/img/list1.083bf30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/list1.png
// module id = R3ye
// module chunks = 0